import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import LoginComponent from '../../Login';
import InformEmail from '../../RecoverPassword/InformEmail';
import NewPassword from '../../RecoverPassword/NewPassword';
import CustomRoute from '../../../../routes/CustomRoute';

export default function Routes() {
  return (
    <Switch>
      <CustomRoute exact path="/login" component={LoginComponent} />
      <CustomRoute exact path="/informEmail" component={InformEmail} />
      <CustomRoute exact path="/newPassword" component={NewPassword} />
      <Route component={() => <Redirect to="/app" />} />
      {/* <Route path="/login" component={LoginComponent} />
      <Route path="/informEmail" component={InformEmail} />
      <Route path="/newPassword" component={NewPassword} /> */}
    </Switch>
  );
}
